export interface MccGroupListResponse {
  id: string
  group: string
}

export interface MccGroupRangeResponse {
  lowest: string
  highest: string
  description: string | null
}

export interface MccGroupCatalogue extends MccGroupListResponse {
  name: string
  validMccRanges: MccGroupRangeResponse[]
}

export interface GetMccGroupListResponse {
  mccGroups: MccGroupListResponse[]
}

export interface GetMccGroupCatalogueResponse {
  mccGroups: MccGroupCatalogue[]
}

export class MccGroupListModel {
  public id: string
  public group: string

  public constructor(r: MccGroupListResponse) {
    this.id = r.id
    this.group = r.group
  }
}
